import { FileText, RefreshCw, Database, Film, Music } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { MarkdownPreview } from './MarkdownPreview';
import { YamlConvert } from './YamlConvert';
import { SqlFormat } from './SqlFormat';
import { VideoTranscode } from './VideoTranscode';
import { MediaDownloader } from './MediaDownloader';

export const converterTools: Tool[] = [
  {
    id: 'markdown-preview',
    name: 'Markdown editor',
    category: 'converters',
    description: 'Live markdown preview with sanitized HTML output.',
    keywords: ['markdown', 'md', 'preview', 'render', 'gfm'],
    icon: FileText,
    component: MarkdownPreview,
    featured: true,
    accepts: 'text',
    inBrowser: true,
  },
  {
    id: 'video-transcode',
    name: 'Video transcoder',
    category: 'converters',
    description: 'Convert video & audio with ffmpeg.wasm — MP4, WebM, GIF, audio extract.',
    keywords: ['video', 'transcode', 'convert', 'mp4', 'webm', 'gif', 'audio', 'ffmpeg'],
    icon: Film,
    component: VideoTranscode,
    featured: true,
    inBrowser: true,
  },
  {
    id: 'media-downloader',
    name: 'Media downloader',
    category: 'converters',
    description: 'Save audio from YouTube, TikTok, Instagram, X — coming soon.',
    keywords: ['youtube', 'tiktok', 'instagram', 'twitter', 'download', 'mp3', 'mp4', 'video', 'audio'],
    icon: Music,
    component: MediaDownloader,
    badge: 'soon',
    inBrowser: false,
  },
  {
    id: 'yaml-convert',
    name: 'YAML ↔ JSON',
    category: 'converters',
    description: 'Bidirectional YAML and JSON conversion.',
    keywords: ['yaml', 'yml', 'json', 'convert'],
    icon: RefreshCw,
    component: YamlConvert,
    inBrowser: true,
  },
  {
    id: 'sql-format',
    name: 'SQL formatter',
    category: 'converters',
    description: 'Reformat SQL with uppercase keywords and indentation.',
    keywords: ['sql', 'format', 'pretty', 'beautify', 'query'],
    icon: Database,
    component: SqlFormat,
    inBrowser: true,
  },
];
